import { useEffect, useRef, useState } from "react";
import { LibraryFolderView, LibraryItem } from "./pasta";
import { Oficio } from "../../services/api/oficios";
import { SegurancaBarragem } from "../../services/api/segBarragem";
import { Seminario } from "../../services/api/seminarios";
import { Simulado } from "../../services/api/simulados";
import { Treinamento } from "../../services/api/treinamentos";
import { Paginated, RequestError, useApi } from "../../services";
import { useBarragemContext } from "../../context";
import { ConfirmModal, ErrorOnDialog } from "../modals";

export const BibliotecaBarragem = () => {
  const api = useApi();
  const { barragem } = useBarragemContext();
  const timerSetItems = useRef<NodeJS.Timeout>();

  const [path, setPath] = useState<string[]>(["Biblioteca da Barragem"]);
  const [destakItems, setDestakItems] = useState<LibraryItem[]>([]);
  const [items, setItems] = useState<LibraryItem[]>([]);
  const [isTrash, setIsTrash] = useState<boolean>(false);
  const [error, setError] = useState<RequestError>();
  const [excludeItem, setExcludeItem] = useState<LibraryItem>();

  const [oficios, setOficios] = useState<Paginated<Oficio>>({ items: [], page: 1, perPage: 100, totalPages: 0, totalItems: 0 });
  const [simulados, setSimulados] = useState<Paginated<Simulado>>({ items: [], page: 1, perPage: 100, totalPages: 0, totalItems: 0 });
  const [seminarios, setSeminarios] = useState<Paginated<Seminario>>({ items: [], page: 1, perPage: 100, totalPages: 0, totalItems: 0 });
  const [treinamentos, setTreinamentos] = useState<Paginated<Treinamento>>({ items: [], page: 1, perPage: 100, totalPages: 0, totalItems: 0 });
  const [segBarragem, setSegBarragem] = useState<Paginated<SegurancaBarragem>>({ items: [], page: 1, perPage: 100, totalPages: 0, totalItems: 0 });

  // Obtendo os ofícios
  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    let fun = api.oficios.getAll;
    if (isTrash) fun = api.oficios.getTrash;

    // Ofícios
    fun(barragem.id, oficios.page, oficios.perPage).then(val => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setOficios(val);
    });

  }, [oficios.page, oficios.perPage, isTrash]);

  // Obtendo as seguranças da barragem
  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    let fun = api.segBarragem.getAll;
    if (isTrash) fun = api.segBarragem.getTrash;

    // Segurança da barragem
    fun(barragem.id, segBarragem.page, segBarragem.perPage).then(val => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setSegBarragem(val);
    });

  }, [segBarragem.page, segBarragem.perPage, isTrash]);

  // Obtendo os Seminários
  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    let fun = api.seminarios.getAll;
    if (isTrash) fun = api.seminarios.getTrash;

    // Seminarios
    fun(barragem.id, seminarios.page, seminarios.perPage).then(val => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setSeminarios(val);
    });

  }, [seminarios.page, seminarios.perPage, isTrash]);

  // Obtendo os simulados
  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    let fun = api.simulados.getAll;
    if (isTrash) fun = api.simulados.getTrash;

    // Simulados
    fun(barragem.id, simulados.page, simulados.perPage).then(val => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setSimulados(val);
    });

  }, [simulados.page, simulados.perPage, isTrash]);

  // Obtendo os Treinamentos
  useEffect(() => {
    if (!barragem || "error" in barragem) return;

    let fun = api.treinamentos.getAll;
    if (isTrash) fun = api.treinamentos.getTrash;

    // Treinamentos
    fun(barragem.id, treinamentos.page, treinamentos.perPage).then(val => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setTreinamentos(val);
    });

  }, [treinamentos.page, treinamentos.perPage, isTrash]);

  // Gerando os items em destaque
  useEffect(() => {
    const destaqueItems: LibraryItem[] = [];

    if (path[path.length - 1] === "Biblioteca da Barragem") {
      destaqueItems.push({
        id: "treinamentos",
        name: "Treinamento",
        type: 'folder',
      });
      destaqueItems.push({
        id: "segBarragem",
        name: "Segurança da Barragem",
        type: 'folder',
      });
      destaqueItems.push({
        id: "seminarios",
        name: "Seminários",
        type: 'folder',
      });
      destaqueItems.push({
        id: "simulados",
        name: "Simulados",
        type: 'folder',
      });
      destaqueItems.push({
        id: "oficios",
        name: "Ofícios",
        type: 'folder',
      });

      // Ofícios mais recentes
      const sorted = [...oficios.items].sort((a, b) => b.dataCadastro.getTime() - a.dataCadastro.getTime());
      if (sorted.length >= 1) {
        destaqueItems.push({
          id: "oficio_1",
          name: sorted[0].file?.split("/")[sorted[0].file?.split("/").length] ?? "",
          type: 'file',
          lastModified: sorted[0].dataCadastro,
        });
      } if (sorted.length >= 2) {
        destaqueItems.push({
          id: "oficio_2",
          type: 'file',
          lastModified: sorted[1].dataCadastro,
          name: sorted[1].file?.split("/")[sorted[1].file?.split("/").length] ?? "",
        });
      } if (sorted.length >= 3) {
        destaqueItems.push({
          id: "oficio_3",
          type: 'file',
          lastModified: sorted[2].dataCadastro,
          name: sorted[2].file?.split("/")[sorted[2].file?.split("/").length] ?? "",
        });
      }
    }

    setDestakItems(destaqueItems);
  }, [oficios, path]);

  // Gerando os items normais
  useEffect(() => {
    timerSetItems.current = setTimeout(() => {
      const pathShowing = path[path.length - 1];
      let items: LibraryItem[] = [];

      // Items do ofício
      if (isTrash || pathShowing === "Biblioteca da Barragem" || pathShowing === "Ofícios") {
        for (const oficio of oficios.items) {
          items.push({
            id: `oficio_${oficio.id}`,
            type: 'file',
            status: !isTrash,
            urlFile: oficio.file,
            name: oficio.tipo ?? "Ofício",
            lastModified: oficio.dataModificacao ?? oficio.dataCadastro,
            size: (oficio.file_size?.toSignificantDigits("formatBytes")) ?? "",
          });
        }
      }

      // Treinamentos
      if (isTrash || pathShowing === "Biblioteca da Barragem" || pathShowing === "Treinamento") {
        for (const treinamento of treinamentos.items) {
          items.push({
            id: `treinamento_${treinamento.id}`,
            type: 'file',
            status: !isTrash,
            urlFile: treinamento.file,
            name: treinamento.tipo ?? "Outro",
            lastModified: treinamento.data,
            size: (treinamento.file_size?.toSignificantDigits("formatBytes")) ?? "",
          });
        }
      }

      // Simulados
      if (isTrash || pathShowing === "Biblioteca da Barragem" || pathShowing === "Simulados") {
        for (const simulado of simulados.items) {
          items.push({
            id: `simulado_${simulado.id}`,
            type: 'file',
            status: !isTrash,
            urlFile: simulado.file,
            name: simulado.tipo ?? "Outro",
            lastModified: simulado.data,
            size: (simulado.file_size?.toSignificantDigits("formatBytes")) ?? "",
          });
        }
      }

      // Seminários
      if (isTrash || pathShowing === "Biblioteca da Barragem" || pathShowing === "Seminários") {
        for (const seminario of seminarios.items) {
          items.push({
            id: `seminario_${seminario.id}`,
            type: 'file',
            status: !isTrash,
            urlFile: seminario.file,
            name: seminario.tipo ?? "Outro",
            lastModified: seminario.data,
            size: (seminario.file_size?.toSignificantDigits("formatBytes")) ?? "",
          });
        }
      }

      // Segurança da Barragem
      if (isTrash || pathShowing === "Biblioteca da Barragem" || pathShowing === "Segurança da Barragem") {
        for (const seg of segBarragem.items) {
          items.push({
            id: `segBarragem_${seg.id}`,
            type: 'file',
            status: !isTrash,
            urlFile: seg.file,
            name: seg.tipo ?? "Outro",
            lastModified: seg.data,
            size: (seg.file_size?.toSignificantDigits("formatBytes")) ?? "",
          });
        }
      }

      if (!isTrash) items = items.filter((it) => it.urlFile);
      if (pathShowing === "Biblioteca da Barragem") items = items.slice(0, 50);

      items.sort((a, b) => (b.lastModified ?? new Date()).getTime() - (a.lastModified ?? new Date()).getTime());
      setItems(items);
    }, 250);

    return () => {
      if (timerSetItems.current) clearTimeout(timerSetItems.current);
    };
  }, [path, oficios, simulados, seminarios, treinamentos, segBarragem]);

  const onExclude = () => {
    if (!excludeItem) return;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let func: any = api.oficios;
    const splitText = excludeItem.id.split("_");
    if (splitText[0] === "simulado") func = api.simulados;
    if (splitText[0] === "seminario") func = api.seminarios;
    if (splitText[0] === "segBarragem") func = api.segBarragem;
    if (splitText[0] === "treinamento") func = api.treinamentos;

    func.remove(Number(splitText[splitText.length - 1])).then((val: (RequestError | Oficio | Simulado | Seminario | Treinamento | SegurancaBarragem)) => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setItems(items.filter((it) => it.id !== excludeItem.id));
    });

    setExcludeItem(undefined);
  };

  const handleSetTrash = () => {
    setItems([]);
    setDestakItems([]);
    setPath(["Biblioteca da Barragem", "Lixeira"]);
    setIsTrash(true);
  };
  const handleExclude = (item: LibraryItem) => {
    setExcludeItem(item);
  };
  const handleRestore = (item: LibraryItem) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let func: any = api.oficios;
    const splitText = item.id.split("_");
    if (splitText[0] === "simulado") func = api.simulados;
    if (splitText[0] === "seminario") func = api.seminarios;
    if (splitText[0] === "treinamento") func = api.treinamentos;
    if (splitText[0] === "segBarragem") func = api.segBarragem;

    func.restore(Number(splitText[splitText.length - 1])).then((val: (RequestError | Oficio | Simulado | Seminario | Treinamento | SegurancaBarragem)) => {
      if ("error" in val) {
        setError(val);
        return;
      }
      setItems(items.filter((it) => it.id !== item.id));
    });
  };
  const handleClick = (item: LibraryItem) => {
    if (item.type === "folder") {
      setItems([]);
      setDestakItems([]);
      setPath([...path, item.name]);
      handleLoadMore();
      return;
    }
    if (item.urlFile) window.open(item.urlFile, '_blank');
  };
  const handleBradcrumb = (paths: string[]) => {
    // Saindo da lixeira
    if (isTrash && paths[paths.length - 1] !== "Lixeira") setIsTrash(false);
    setPath(paths);
  };
  const handleLoadMore = () => {
    setOficios({ ...oficios, perPage: Math.max(1, Math.min(oficios.totalItems, oficios.perPage + 100)) });
    setSimulados({ ...simulados, perPage: Math.max(1, Math.min(simulados.totalItems, simulados.perPage + 100)) });
    setSeminarios({ ...seminarios, perPage: Math.max(1, Math.min(seminarios.totalItems, seminarios.perPage + 100)) });
    setSegBarragem({ ...segBarragem, perPage: Math.max(1, Math.min(segBarragem.totalItems, segBarragem.perPage + 100)) });
    setTreinamentos({ ...treinamentos, perPage: Math.max(1, Math.min(treinamentos.totalItems, treinamentos.perPage + 100)) });
  };

  return <>
    {error && <ErrorOnDialog open={Boolean(error)} onClose={() => setError(undefined)} {...error} />}
    {excludeItem && <ConfirmModal
      open={Boolean(excludeItem)}
      title="Deseja mover este item para a lixeira?"
      message="Isto irá mover o item e todos os dados dele para a lixeira. Mas não se preocupe, você pode restaurar estes dados a qualquer momento em 'Lixeira'"
      onCancel={() => setExcludeItem(undefined)}
      onConfirm={onExclude}
    />}

    <LibraryFolderView
      titleBradcrumb={path.length > 1}
      title={path.join("/")}
      items={items}
      showTrash={!isTrash}
      destakItems={destakItems}
      onItemClick={handleClick}
      onExclude={handleExclude}
      onRestore={handleRestore}
      onLoadMore={handleLoadMore}
      onTrashClick={handleSetTrash}
      onBradcrumbClick={handleBradcrumb}
    />
  </>;
};